module.exports = __webpack_public_path__ + "assets/f6e7de47c04cd83020b30b26c44283de.svg";